import { IconButton } from "@mui/material";
import type { IconButtonProps } from "@mui/material";
import classNames from "classnames";
import styles from "./styles.module.css";
import { forwardRef } from "react";

interface Props extends IconButtonProps {
  buttonType?: "contained" | "outlined" | "text";
  big?: boolean;
  warning?: boolean;
  disabled?: boolean;
}

export const AppIconButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      className,
      buttonType = "text",
      big,
      warning,
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <IconButton
        ref={ref}
        className={classNames(
          styles.button,
          styles[buttonType],
          {
            [styles.big]: big,
            [styles.warning]: warning,
            [styles.disabled]: disabled,
          },
          className,
        )}
        disabled={disabled}
        centerRipple={false}
        {...props}
      >
        {children}
      </IconButton>
    );
  },
);
